import script from "./policy-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./policy-detail.vue?vue&type=script&setup=true&lang=ts"

import "./policy-detail.vue?vue&type=style&index=0&id=982f0eba&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-982f0eba"]])

export default __exports__